module.exports = "{{prefix}} {{text}} {{postfix}}"